function keyIsPrintable(e) {
    if (e.key.length === 1) {
        return true;
    }
    return false;
}

function isDeleteChar(e) {
    const deleteKeys = ['Backspace', 'Delete'];
    if (deleteKeys.includes(e.key)) {
        return true;
    }
    return false;
}

function paramObjFromURL(url) {
    try {
        const queryString = url.match(/\?[^$]*$/)[0];
        return new URLSearchParams(queryString);
    }
    catch (err) {
        console.error("Query string could not be parsed from URL, event will be missing parameters: ", err);
        return new URLSearchParams();
    }
}

function searchIDFromData(data) {
    try {
        let newSearchID = data.match(/data-search-id=[^ ]*? /)[0].slice('data-search-id='.length);
        newSearchID = newSearchID.replaceAll('"', '');
        newSearchID = newSearchID.replaceAll(' ', '');
        return newSearchID;
    }
    catch(err) {
        console.error(`SearchID could not be parsed for event: ${err}`);
        return '';
    }
}

export { keyIsPrintable, isDeleteChar, paramObjFromURL, searchIDFromData };